import { createSelector } from '@ngrx/store';

import { AppState } from '@core/store';

export const selectAccesosState = (state: AppState) => state.accesos;

export const currentAccesos = createSelector(selectAccesosState, (accesos) => accesos.accesos);

export const loadedAccesos = createSelector(selectAccesosState, (accesos) => accesos.loaded);
